import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const libraries = ["places"];

export const MapComponent = (props) => {
  const { supplyNote } = props;

  return (
    <LoadScript
      libraries={libraries}
      googleMapsApiKey={process.env.REACT_APP_MAPS_API_KEY}
    >
      <GoogleMap
        mapContainerClassName="form_customer_map"
        zoom={18}
        center={{
          lat: (supplyNote?.initialLatitude + supplyNote?.finalLatitude) / 2,
          lng: (supplyNote?.initialLongitude + supplyNote?.finalLongitude) / 2,
        }}
        options={{
          fullscreenControl: false,
        }}
      >
        <Marker
          draggable
          position={{ lat: supplyNote?.initialLatitude, lng: supplyNote?.initialLongitude }}
          title="Inicio"
          label="I"
        />
        <Marker
          draggable
          position={{ lat: supplyNote?.finalLatitude, lng: supplyNote?.finalLongitude }}
          title="Final"
          label="F"
        />
      </GoogleMap>
    </LoadScript>
  );
};
